export const GET_DIAG_OVERVIEW = 'GET_DIAG_OVERVIEW';
export const GET_DIAG_ID_FAULTS = 'GET_DIAG_ID_FAULTS';
export const GET_DIAG_FAULTS_ID = 'GET_DIAG_FAULTS_ID';
export const GET_SENSORS = 'GET_SENSORS';
export const GET_ALL_FAULTS = 'GET_ALL_FAULTS';
